import { render } from "./PeriodicReports.vue?vue&type=template&id=707a4c18"
import script from "./PeriodicReports.vue?vue&type=script&lang=js"
export * from "./PeriodicReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__